export class TypeUtils {

  public static isObject(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  public static isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  }

  public static isArray(value: any): boolean {
    return Array.isArray(value);
  }

  public static isBoolean(value: any): boolean {
    return value instanceof Boolean || typeof value === 'boolean';
  }

  public static isNumber(value: any): boolean {
    return typeof value === 'number';
  }

  public static isString(value: any): boolean {
    return typeof value === 'string';
  }


  public static isUndefined(value: any): boolean {
    return typeof value === 'undefined';
  }

  public static isDefined(value: any): boolean {
    return typeof value !== 'undefined';
  }

  public static isFile(value: any): boolean {
    return value instanceof File;
  }

  public static cloneDeep(value: any, level: number = -1): any {
    if (TypeUtils.isObject(value)) {
      let clone: object;

      if (level !== 0) {
        clone = {};

        Object.keys(value).forEach((key: string): void => {
          clone[key] = TypeUtils.cloneDeep(value[key], level - 1);
        });
      }
      else {
        clone = value;
      }

      return clone;
    }

    if (TypeUtils.isArray(value)) {
      return value.map((item: any): any => {
        return TypeUtils.cloneDeep(item);
      });
    }

    return value;
  }

  public static isEmpty(value: any): boolean {
    if (TypeUtils.isArray(value) || TypeUtils.isString(value)) {
      return value.length === 0;
    }

    if (TypeUtils.isObject(value)) {
      return Object.keys(value).length === 0;
    }

    return true;
  }

  public static isNull(value: any): boolean {
    return value === null;
  }

  public static arrayHasDuplicates(array) {
    let valuesSoFar = Object.create(null);
    for (let i = 0; i < array.length; ++i) {
      let value = array[i];
      if (value in valuesSoFar) {
        return true;
      }
      valuesSoFar[value] = true;
    }
    return false;
  }

  public static sameUrl(newUrl, baseUrl, baseCheck = false) {
    const _baseUrl = baseUrl && baseUrl.replace('https://', '').replace('http://', '')
      .replace('www.', '').replace(/\/$/, "");
    let _newUrl = newUrl && newUrl.replace('https://', '').replace('http://', '')
      .replace('www.', '').replace(/\/$/, "");
    if (baseCheck) {
      _newUrl = _newUrl.split(/[/?#]/)[0];
    }
    return _newUrl === _baseUrl;
  }



}
